export enum AppLoginType {
    RightLogin = "RightLogin",
    CenterLogin = "CenterLogin",
    LoginWithCarousel = "LoginWithCarousel",
}






